import { AlertTriangle, Inbox, RefreshCw } from "lucide-react";

export const LoadingState = ({ label = "Loading operational data" }) => (
  <div className="state-panel" data-testid="page-loading-state">
    <div className="radar-loader small" aria-hidden="true" />
    <span>{label}…</span>
  </div>
);

export const ErrorState = ({ message, onRetry }) => (
  <div className="state-panel error" role="alert" data-testid="page-error-state">
    <AlertTriangle size={20} />
    <div><strong>Request failed</strong><p>{message}</p></div>
    <button className="icon-button" onClick={onRetry} aria-label="Retry request" data-testid="retry-request-button"><RefreshCw size={17} /></button>
  </div>
);

export const EmptyState = ({ label }) => (
  <div className="state-panel" data-testid="page-empty-state"><Inbox size={20} /><span>{label}</span></div>
);